<template>
  <div class="single-list-container">
    <div v-for="item in data" :key="item.id" @click="showDetailItem(item)">
      <!-- 电影/剧集：左图右文 -->
      <div class="movie-item" v-if="item.type === 4 || item.type === 5">
        <div class="cover-container">
          <img v-lazy="item.cover_url || ''" :key="item.id" class="cover"/>
        </div>
        <div class="movie-info-box">
          <div class="title-info">{{item.title}}</div>
          <div class="description-info">
            {{movieDescriptions(item)}}
          </div>
          <div class="plot-info" v-if="item.description">
            {{item.description}}
          </div>
        </div>
      </div>
      <!-- 普通视频：全宽大图 + 蒙层标题 -->
      <div class="video-item-large" v-if="item.type === 0">
        <div class="video-large-cover">
          <img v-lazy="item.cover_url" :key="item.id" class="cover"/>
          <div class="video-large-mask"></div>
          <div class="video-large-title">
            {{item.title}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {ugcItemTypeMovie, ugcItemTypeSeries} from "../../util/const";

  export default {
    name: "MovieItemList",
    props: {
      data: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      showDetailItem(item) {
        if (item.type === 2) {
          this.$router.push('/novel/' + item.id);
        } else if (item.type === 0) {
          this.$router.push('/video/' + item.id);
        } else if (item.type === ugcItemTypeMovie || item.type === ugcItemTypeSeries) {
          this.$router.push("/movie/" + item.id)
        }
      },
      movieDescriptions(movieItem) {
        let movieInfo = movieItem.movie_info
        let result = ''
        if (movieInfo.tags) {
          result += '' + movieInfo.tags
        } else if (movieInfo.alias) {
          result += '别名：' + movieInfo.alias
        }
        return result
      }
    }
  };
</script>

<style lang="scss" scoped>

  .single-list-container {
    width: 100%;
    background: white;
  }

  /* ===== 电影/剧集：左图右文 ===== */
  .movie-item {
    display: flex;
    padding: 10px 8px;
    background: white;
    border-bottom: 1px solid #f5f5f5;
  }

  .cover-container {
    flex: 0 0 auto;
    width: 120px;
    height: 190px;
    overflow: hidden;
    background: #fafafa;
    border-radius: 5px;

    .cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      border-radius: 5px;
    }
  }

  .movie-info-box {
    flex: 1 1 auto;
    padding: 5px 12px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .title-info {
      font-size: 14px;
      font-weight: bold;
      color: #222;
      line-height: 1.3;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    .description-info {
      margin-top: 4px;
      font-size: 12px;
      line-height: 1.4;
      overflow: hidden;
      color: #999;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }

    .plot-info {
      margin-top: auto;
      font-size: 12px;
      line-height: 1.5;
      color: #555;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }

  /* ===== 普通视频：全宽大图 ===== */
  .video-item-large {
    padding: 10px 8px;
    background: white;
  }

  .video-large-cover {
    width: 100%;
    height: 200px;
    overflow: hidden;
    position: relative;
    background: #fafafa;
    border-radius: 8px;

    .cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .video-large-mask {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 55%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.75), transparent);
    pointer-events: none;
  }

  .video-large-title {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px 12px;
    font-size: 15px;
    color: white;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    box-sizing: border-box;
  }

</style>
